import { render } from "./receiveScan.vue?vue&type=template&id=ebf4a624&scoped=true"
import script from "./receiveScan.vue?vue&type=script&lang=js"
export * from "./receiveScan.vue?vue&type=script&lang=js"

import "./receiveScan.vue?vue&type=style&index=0&id=ebf4a624&scoped=true&lang=css"

import exportComponent from "D:\\projects\\wmsapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf4a624"]])

export default __exports__